import React, { useEffect, useState } from "react";
import { Stack, Grid, Flex, Text, Group } from "@mantine/core";
import Intercom from "@intercom/messenger-js-sdk";
import { update } from "@intercom/messenger-js-sdk";

//docs https://developers.intercom.com/installing-intercom/web/methods#intercomupdate

const IntercomBot: React.FC = () => {
  Intercom({
    app_id: "bnfrr1b2",
    alignment: "right",
    horizontal_padding: 64,
    vertical_padding: 64,
  });

  const hideChat = () => {
    setChatHidden(true);
    update({ z_index: -15 });
  };

  const showChat = () => {
    setChatHidden(false);
    update({ z_index: 15 });
  };

  const [chatHidden, setChatHidden] = useState(false);

  return (
    <Flex className="w-full h-full flex flex-col justify-center items-center">
      <div className="flex flex-col h-screen w-full bg-black justify-center items-center">
        <button
          className="w-[200px] h-[64px] bg-white text-black rounded-[12px]"
          onClick={chatHidden ? showChat : hideChat}
        >
          {chatHidden ? "Show" : "Hide"} chat programmatically
        </button>
      </div>
    </Flex>
  );
};

export default IntercomBot;
